import type { SourceProvider } from "@aion/xo-core";

export const ProviderIcon = ({ provider }: { provider: SourceProvider }) => {
  if (provider === "gmail") {
    return (
      <svg className="provider-icon" viewBox="0 0 24 24" aria-label="Gmail">
        <path fill="#4285F4" d="M3 5.5v13h3.4V9.3L12 13.4l5.6-4.1v9.2H21v-13l-9 6.7-9-6.7Z" />
        <path fill="#EA4335" d="M3 5.5 12 12.2 21 5.5v4.1L12 16.2 3 9.6V5.5Z" />
        <path fill="#FBBC04" d="M3 9.6 6.4 12v6.5H3V9.6Z" />
        <path fill="#34A853" d="M17.6 12 21 9.6v8.9h-3.4V12Z" />
      </svg>
    );
  }
  if (provider === "slack") {
    return (
      <svg className="provider-icon" viewBox="0 0 24 24" aria-label="Slack">
        <rect x="9" y="2" width="4" height="9" rx="2" fill="#36C5F0" />
        <rect x="13" y="9" width="9" height="4" rx="2" fill="#2EB67D" />
        <rect x="11" y="13" width="4" height="9" rx="2" fill="#ECB22E" />
        <rect x="2" y="11" width="9" height="4" rx="2" fill="#E01E5A" />
      </svg>
    );
  }
  if (provider === "asana") {
    return (
      <svg className="provider-icon" viewBox="0 0 24 24" aria-label="Asana">
        <circle cx="12" cy="6.5" r="4" fill="#F06A6A" />
        <circle cx="6.5" cy="16.5" r="4" fill="#F06A6A" />
        <circle cx="17.5" cy="16.5" r="4" fill="#F06A6A" />
      </svg>
    );
  }
  if (provider === "notion") {
    return (
      <svg className="provider-icon" viewBox="0 0 24 24" aria-label="Notion">
        <rect x="3" y="3" width="18" height="18" rx="1" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M7 17V7l2.2-.2 6.1 8V8.2L13.6 8V7h4.2v1l-1.3.2V17h-1.8L8.2 8.7V16l1.8.3v.7H7Z" fill="currentColor" />
      </svg>
    );
  }
  if (provider === "calendar") {
    return (
      <svg className="provider-icon" viewBox="0 0 24 24" aria-label="Calendar">
        <rect x="3" y="4" width="18" height="17" rx="2" fill="#4285F4" />
        <path d="M3 8h18v3H3z" fill="#fff" opacity=".9" />
        <text x="12" y="18" textAnchor="middle" fontSize="8" fontWeight="700" fill="#fff">31</text>
      </svg>
    );
  }
  return <span className="provider-icon provider-icon--xo">✦</span>;
};
